import { render, staticRenderFns } from "./SingleLineForDesktop.vue?vue&type=template&id=ebec4c52&"
import script from "./SingleLineForDesktop.vue?vue&type=script&lang=js&"
export * from "./SingleLineForDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports